import { render, staticRenderFns } from "./MailErrors.vue?vue&type=template&id=39c09988&"
import script from "./MailErrors.vue?vue&type=script&lang=js&"
export * from "./MailErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports